<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <GlobalTable
        :enableAddButton ="false"
        :title="title+' List'"
        :fields="fields"
        :items="items"
        :editButton="false"
        :redirectDetail="true"
        :isLoading="isLoading"
        :withCard="false"
      ></GlobalTable>
    </div>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import Loading from "@/templates/Loading";

export default {
  name: "Questionnaire",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Questionnaire",
      fields: [
        { key: "pertanyaan", label: "Question", sorter: true },
        { key: "jawaban", label: "Answer", sorter: true },
      ],
      q_items:[],
      showImages: "",
      preview: false
    };
  },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
        type: Boolean,
        default: false
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
    },
    back: function () {
      this.$router.go(-1);
    },
    
    previewImages: function (img) {
        this.showImages = "";
        this.preview = true;
        this.showImages = img;
    },
  
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
